import SettingsApi from "../api/service/settings/SettingsApi";

export default class SettingsService {
    api;

    constructor() {
        this.api = new SettingsApi();
    }

    // ===================== Notice =====================

    async getNotice({ country, targetClientType }) {
        return this.api.getNotice({ country, targetClientType }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async saveNotice(reqDto) {
        return this.api.saveNotice(reqDto).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async updateNotice(reqDto) {
        return this.api.updateNotice(reqDto).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async deleteNotice({ country, targetClientType }) {
        return this.api.deleteNotice({ country, targetClientType }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    // ===================== Guide =====================

    async getGuideList(params) {
        return this.api.getGuideList(params).then((res) => {
            if (res.resultCode === "0000") {
                return { result: res.result, count: res.count, totalCount: res.totalCount };
            } else {
                throw new Error(res.result);
            }
        });
    }

    async saveGuide(reqDto) {
        return this.api.saveGuide(reqDto).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async updateGuide(reqDto) {
        return this.api.updateGuide(reqDto).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async deleteGuide({ guideId }) {
        return this.api.deleteGuide({ guideId }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    // ===================== Course Image & Price =====================

    async getCourseImages({ imageNum, version, page = 1, pageSize = 10 } = {}) {
        return this.api
            .getCourseImages({
                imageNum,
                version,
                page,
                pageSize,
            })
            .then((res) => {
                if (res.resultCode === "0000") {
                    return res.result;
                } else {
                    throw new Error(res.result);
                }
            });
    }

    async uploadCourseImage({ imageNum, version, content }) {
        return this.api.uploadCourseImage({ imageNum, version, content }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async deleteCourseImage({ imageNum, version }) {
        return this.api.deleteCourseImage({ imageNum, version }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async updateCoursePrice({ deviceId, reqDto }) {
        return this.api.updateCoursePrice({ deviceId, reqDto }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }
}
